module.exports = __webpack_public_path__ + "ProximaNova-Regular.d900267b81d8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/ProximaNova-Regular.woff
// module id = ./src/styles/fonts/ProximaNova-Regular.woff
// module chunks = 21